import React from 'react'
import clsx from 'clsx'
import Image from '../Image/Image'
import { Link } from 'gatsby'

export const Blogcard = ({
  otherClasses,
  slug,
  title,
  mobileImage,
  blogCategory: { category },
}) => {
  const blogcardClasses = clsx(otherClasses, 'w-full')

  return (
    <Link
      to={`/${slug.current}`}
      className={blogcardClasses}
      data-testid="blogcard"
    >
      <div className="rounded-3xl overflow-hidden">
        <Image imageData={mobileImage} otherClasses="w-full object-cover" />
      </div>
      <p className="font-work-sans font-semibold tracking-[0.42px] uppercase text-sm leading-[18px] text-gray-600 mb-2 mt-6">
        {category}
      </p>
      <p className="font-work-sans text-2xl leading-[34px] text-primary_heading_color font-semibold">
        {title}
      </p>
    </Link>
  )
}

export default Blogcard
